export default __webpack_public_path__ + "static/media/read-disabled.96ec551a.svg";